import { translations as uilibtranslations } from "./ui-lib-translations";

const vlabtranslations = {
	en: {
		translation: {
			"common": {
				start: "Start",
				confirmation: "Are you sure you want to submit?"
			},
			"proctor": {
				INITIATE_PROCTOR_LOGIN: "Logging into session...",
				INITIALIZING: "Getting ready...",
				PROCTOR_CHILD_READY: "Getting ready...",
				PROCTOR_CHILD_LOGGED_IN: "Logged in",
				APPLICATION_TIMEOUT: "Proctor Application is taking longer than expected to load"
			},
			"scale-landing": {
				"weight-capture": "Let's capture your weight",
				"instruction": "Please step onto the scale and point your back camera to capture the weight display.",
				"instruction-item-1": "Light clothing without shoes",
				"instruction-item-2": "Scale on a flat and stable surface"
			},
			"navigator": {
				"back-btn": "Back",
				"submit-btn": "Submit"
			},
			"agent-wait-time":
				"We apologise for the wait. Our team is currently experiencing higher than usual demand. Your current wait time can reach up to {{WAIT_TIME}} minutes. If this timing doesn't work for you, you're welcome to try again later for potentially faster service. Thank you for your patience — we're working hard to assist you as quickly as possible.",
			"agent-wait-soon": "We will be with you shortly.",
			"agent-long-wait":
				"We apologise for the wait. Our team is currently experiencing higher than usual demand. Your current wait time is over 30 minutes. If this timing doesn't work for you, you're welcome to try again later for potentially faster service. Thank you for your patience — we're working hard to assist you as quickly as possible.",
			"agent-wait-time-high-priority":
				"You are in a high priority wait queue. We will connect you as soon as possible.",
			"all-set": "You're all set!",
			"check-mic": "Let's check your microphone",
			"checking": "Checking",
			"connect-agent": "Please hold while we connect you.",
			"connection-lost": "Connection has been lost",
			"continue": "Continue",
			"could-not-hear": "We couldn't hear anything.",
			"different-device": "Let's try a different device.",
			"duplicate-sessions":
				"You have a session open in another window. Please close the other window and refresh this page to try again.",
			"failed": "Failed",
			"finish": "Finish",
			"for-additional-help": "Click here for additional help",
			"hear-you": "Great, we hear you loud and clear!",
			"how-about-now": "How about now?",
			"have-questions-visit": "Have Questions? Visit",
			"listening-on": "Listening on",
			"loading": "Loading",
			"manual-settings": "Manual settings",
			"next": "Next",
			"Note": "Note",
			"not-detected": "NOT DETECTED",
			"playing_on": "Playing on",
			"refresh-page-help": "Refreshing this page might help solve the problem.",
			"save-settings":
				"Thanks for your patience — we'll save your settings for future use so you won't have to do this again.",
			"say-mic": "Try saying something into your microphone.",
			"scanner-error": "Failed to scan",
			"scanning": "Scanning",
			"see-hear": "Let's make sure we can hear and see you.",
			"start-device-setup": "Click the start button to begin the process of setting up your device.",
			"stop-sound": "Stop Sound",
			"success": "Success",
			"thankyou-for-choosing": "Thank you for choosing eMed.",
			"thankyou-for-choosing-shemed": "Thank you for choosing SheMed.",
			"thankyou-for-choosing-hemed": "Thank you for choosing HeMed.",
			"test-sound": "Test Sound",
			"to-reconnect": "to reconnect",
			"to-refresh-page": "to refresh the page",
			"try-again": "Try again",
			"click-here": "Click here",
			"warnings": {
				"warning": "Warning",
				"reconnecting": "Reconnecting...",
				"slow-internet": "Slow Internet",
				"your-internet-connection-is-slow": "Your internet connection is slow"
			},
			"av-errors": {
				"av-error-occurred": "An audio/video error occurred.",
				"microphone":
					"Unable to access your microphone. Permissions may not have been granted. Please reload and grant permissions.",
				"speaker":
					"Unable to send audio to your speakers. Permissions may not have been granted. Please reload and grant permissions.",
				"camera":
					"Unable to access your camera. Permissions may not have been granted. Please reload and grant permissions."
			},
			"readiness-checker": {
				"continue": "{{continue}}",
				"check-speech-recognition": "Speech Recognition",
				"check-speech-recognition-failed":
					"Please check that you have enabled permissions for Speech Recognition, and try again",
				"check-motion-and-orientation": "Motion and orientation",
				"check-motion-and-orientation-failed":
					"Please check that you have enabled permissions for motion, and try again",
				"check-permissions": "Device permissions",
				"check-permissions-failed":
					"Please check that you have enabled permissions for Camera & Microphone, and try again",
				"audio-input-permission": "Microphone requires browser permission",
				"camera": "Camera",
				"check-device-ready": "Checking your device",
				"check-device-ready-note":
					"You’ll be connecting to the procedure next, if you want to use headphones, connect them now",
				"check-device-ready-note-shemed": "You’ll be connecting to a SheMed Team Member next",
				"check-device-ready-note-hemed": "You’ll be connecting to a HeMed Team Member next",
				"click-here": "{{click-here}}",
				"confirm-continue":
					"There is a problem with your speaker. If you experience audio difficulty during your session, you can communicate using the chat window.",
				"device-problem": "There is a problem with your",
				"device-ready": "Your device is ready!",
				"disclaimer":
					"*To provide the best testing experience, eMed will access your camera and microphone. If you'd prefer not to enable them, you can still use the chat to communicate with the proctor, but some features will be limited.",
				"disclaimer-shemed":
					"*To provide the best testing experience, SheMed will access your camera and microphone. If you'd prefer not to enable them, you can still use the chat to communicate with the proctor, but some features will be limited.",
				"disclaimer-hemed":
					"*To provide the best testing experience, HeMed will access your camera and microphone. If you'd prefer not to enable them, you can still use the chat to communicate with the proctor, but some features will be limited.",
				"hear-sound": "Do you hear the sound we're playing?",
				"microphone": "Microphone",
				"microphone-permission": "Your internet browser does not have permission to access your microphone.",
				"network": "Network",
				"no": "No",
				"skip": "Skip",
				"speaker": "Speakers",
				"start": "Start device check",
				"start-testing-button": "Let's start your testing",
				"start-the-test": "Start the test",
				"steps-failed": "One or more steps failed.",
				"thanks-for-providing-information": "Let's check if your device is ready",
				"readiness-steps": {
					"step-1": "Allow eMed the access to your camera and microphone* when prompted.",
					"step-2": "We will check your device for internet, camera, microphone and speaker.",
					"step-3": "Connect to the Proctor guide for your testing session."
				},
				"readiness-steps-shemed": {
					"step-1": "Allow SheMed the access to your camera and microphone* when prompted.",
					"step-2": "We will check your device for internet, camera, microphone and speaker.",
					"step-3": "Connect to a SheMed team member to guide through today’s session."
				},
				"readiness-steps-hemed": {
					"step-1": "Allow HeMed the access to your camera and microphone* when prompted.",
					"step-2": "We will check your device for internet, camera, microphone and speaker.",
					"step-3": "Connect to a HeMed team member to guide through today’s session."
				},
				"to-try-again": "to try again",
				"video-permission": "Your internet browser does not have permission to access your camera.",
				"yes": "Yes",
				"device-check-failed": "One or more device checks have failed.",
				"confirm-device-settings":
					"Please confirm in your device's Settings that Camera and Microphone use are enabled.",
				"troubleshooting-guides-title":
					"If you are having trouble locating this feature in your device settings, please reference the below material.",
				"using-mobile": "If using a mobile device",
				"using-desktop-laptop": "If using a desktop or laptop",
				"still-having-trouble_us":
					"Still having trouble connecting? Contact eMed Customer service <a class='has-text-link' href='https://support.emed.com/s/?language=en_US' target='_blank'><u>here</u></a>.",
				"still-having-trouble_uk":
					"Still having trouble connecting? Contact eMed Customer service <a class='has-text-link' href='https://emed.com/uk/contact' target='_blank'><u>here</u></a>.",
				"confirm-device-settings-shemed":
					"Please confirm the SheMed app has permission to use your device camera and microphone.",
				"confirm-device-settings-hemed":
					"Please confirm the HeMed app has permission to use your device camera and microphone.",
				"device-check-failed-shemed": "One or more device checks have failed.",
				"device-check-failed-hemed": "One or more device checks have failed.",
				"try-again": "Try again",
				"try-again-shemed": "Try again",
				"try-again-hemed": "Try again",
				"device-guides-shemed": {
					iphone: {
						"step-1": "Open Settings on your iPhone",
						"step-2": "Tap Privacy & Security",
						"step-3": "Select Camera",
						"step-4": 'Locate the SheMed app and toggle the switch to the "on" position',
						"step-5": "Return to the Privacy & Security menu and repeat these steps for Microphone",
						"title": "If using an <b>iPhone (iOS)</b>:",
						"more-information":
							"For more information on managing camera and microphone access on your iPhone, visit Apple support <a class='has-text-link' href='https://support.apple.com/en-gb/contact' target='_blank'><u>here</u></a>."
					},
					android: {
						"step-1": "Access your phone's settings",
						"step-2": 'Select "Apps" or "Applications"',
						"step-3": "Find and tap the SheMed app",
						"step-4": 'Tap "Permissions"',
						"step-5": 'Toggle the "Camera" and "Microphone" options to "Allow"',
						"title": "If using an <b>Android device</b>:",
						"more-information":
							"For more information on managing camera and microphone access on your Android device, visit Android support <a class='has-text-link' href='https://support.google.com/android/?hl=en-GB' target='_blank'><u>here</u></a>."
					}
				},
				"device-guides-hemed": {
					iphone: {
						"step-1": "Open Settings on your iPhone",
						"step-2": "Tap Privacy & Security",
						"step-3": "Select Camera",
						"step-4": 'Locate the HeMed app and toggle the switch to the "on" position',
						"step-5": "Return to the Privacy & Security menu and repeat these steps for Microphone",
						"title": "If using an <b>iPhone (iOS)</b>:",
						"more-information":
							"For more information on managing camera and microphone access on your iPhone, visit Apple support <a class='has-text-link' href='https://support.apple.com/en-gb/contact' target='_blank'><u>here</u></a>."
					},
					android: {
						"step-1": "Access your phone's settings",
						"step-2": 'Select "Apps" or "Applications"',
						"step-3": "Find and tap the HeMed app",
						"step-4": 'Tap "Permissions"',
						"step-5": 'Toggle the "Camera" and "Microphone" options to "Allow"',
						"title": "If using an <b>Android device</b>:",
						"more-information":
							"For more information on managing camera and microphone access on your Android device, visit Android support <a class='has-text-link' href='https://support.google.com/android/?hl=en-GB' target='_blank'><u>here</u></a>."
					}
				},
				"device-guides": {
					iphone: {
						"step-1": "Open Settings on your iPhone",
						"step-2": "Tap Safari (or your default browser)",
						"step-3": "Tap Camera",
						"step-4": "Allow access",
						"step-5": "Go back and repeat these steps for Microphone",
						"title": "If using an <b>iPhone (iOS)</b>:",
						"more-information":
							"For more information on managing camera and microphone access on your iPhone, visit Apple support <a class='has-text-link' href='https://support.apple.com/en-gb/contact' target='_blank'><u>here</u></a>."
					},
					android: {
						"step-1": "Access your phone's settings",
						"step-2": 'Select "Apps" or "Applications"',
						"step-3": "Find and tap the default browser app",
						"step-4": 'Tap "Permissions"',
						"step-5": 'Toggle the "Camera" and "Microphone" options to "Allow"',
						"title": "If using an <b>Android device</b>:",
						"more-information":
							"For more information on managing camera and microphone access on your Android device, visit Android support <a class='has-text-link' href='https://support.google.com/android/?hl=en-GB' target='_blank'><u>here</u></a>."
					},
					mac: {
						"step-1": "Click the Apple menu",
						"step-2": 'Select "System Settings"',
						"step-3": 'Click "Security & Privacy"',
						"step-4": 'Select either "Camera" or "Microphone" on the left side',
						"step-5": "Toggle the switch next to the app you want to allow access",
						"title": "If using a <b>Mac device</b>:",
						"more-information":
							"For more information on managing camera and microphone access on your Mac, visit Apple support <a class='has-text-link' href='https://support.apple.com/' target='_blank'><u>here</u></a>."
					},
					windows: {
						"step-1": 'Navigate to "Start > Settings > Privacy"',
						"step-2": 'Choose "Camera" or "Microphone" depending on which permission you\'d like to grant',
						"step-3": 'Select "Camera" or "Microphone" on the left side',
						"step-4":
							'Make sure that the toggle switch next to "Allow apps to access your camera/microphone" is turned on',
						"title": "If using a <b>Windows device</b>:",
						"more-information":
							"For more information on managing camera and microphone access on your Windows PC, visit Microsoft support <a class='has-text-link' href='https://support.microsoft.com/en-us' target='_blank'><u>here</u></a>."
					}
				},
				"proceed-anyway-shemed":
					"If permissions are enabled and you are still seeing this screen, you can still connect to a proctor by clicking below.",
				"proceed-anyway-cta-shemed": "Continue Anyway",
				"still-having-trouble-shemed":
					"Still having trouble connecting? Contact SheMed Customer service <a class='has-text-link' href='https://support.shemed.co.uk/s/' target='_blank'><u>here</u></a>.",
				"proceed-anyway-hemed":
					"If permissions are enabled and you are still seeing this screen, you can still connect to a proctor by clicking below.",
				"proceed-anyway-cta-hemed": "Continue Anyway",
				"still-having-trouble-hemed":
					"Still having trouble connecting? Contact HeMed Customer service <a class='has-text-link' href='https://support.hemed.com/s/' target='_blank'><u>here</u></a>.",
				"proceed-anyway":
					"If permissions are enabled and you are still seeing this screen, you can still connect to a proctor by clicking below.",
				"proceed-anyway-cta": "Continue Anyway"
			},
			"widgets": {
				"continue": "{{continue}}",
				"incomplete-warning": "Please complete the form and try again.",
				"interpretations": {
					invalid: "Invalid",
					negative: "Negative",
					other: "Other",
					positive: "Positive",
					two_lines: "Two Lines",
					top_line: "Top Line",
					bottom_line: "Bottom Line",
					no_line: "No Line"
				},
				"loading-failure": "Unable to retrieve data",
				"loading-result": "Retrieving result",
				"multi-observation": {
					"lab-specific-names": {
						"nih-covid-flu": {
							"observation/17": "Cov19",
							"observation/28": "Flu A",
							"observation/29": "Flu B"
						}
					}
				},
				"no-photo-title": "NO PHOTO FOUND",
				"refresh-image": "REFRESH IMAGE",
				"save-failed": "Could not save results. Please try again",
				"select": "Select",
				"submit": "Submit",
				"camera-widget": {
					"button-capture-photo": "Capture Photo",
					"button-upload-photo": "Upload Photo",
					"capture-error": "There was a problem capturing your image. Please refresh, and try again.",
					"confirm-photo": "Looks good",
					"instruction-message": "",
					"reject-photo": "Retake",
					"save-error": "There was a problem saving your result. Please try again.",
					"verify-image-message": "If the photo is clear and readable, click 'Looks good' to continue",
					"take-a-photo": "You will use your device camera to take a photo of your test.",
					"clear-photo-question": "Are all items visible and clear?",
					"source-error":
						"We couldn't access the video stream, please check camera permissions, other app usage, and your internet connection.",
					"successful-upload": "Upload succeeded",
					"processing": "Processing",
					"cancel": "Cancel",
					"button-instructions": "TAKE A PICTURE",
					"native-capture-heading": "Let's capture your results!",
					"native-capture-instruction":
						"When you are ready to take the photo, please click below and the camera will open to take the photo.",
					"upload": "Upload"
				},
				"cardio-check-form": {
					"auto-fill": "Auto Fill",
					"chol": "Cholesterol",
					"hdlChol": "HDL Cholesterol",
					"trig": "Triglycerides",
					"eglu": "Fasting Blood Glucose",
					"time": "Time",
					"date": "Date",
					"calcLdl": "Calculated LDL Cholesterol",
					"tcHdl": "Total Chol to HDL Chol ratio",
					"ldlHdl": "LDL Chol to HDL Chol ratio",
					"nonHdl": "Non-HDL Cholesterol",
					"chol-short": "TC",
					"hdlChol-short": "HDL",
					"trig-short": "Trig",
					"eglu-short": "eglu",
					"calcLdl-short": "Calc LDL",
					"tcHdl-short": "TC/HDL Ratio",
					"ldlHdl-short": "LDL/HDL Ratio",
					"nonHdl-short": "Non-HDL",
					"chol-validation-message": "Validating a 3-digit number from 0 to 200",
					"hdlChol-validation-message": "Validating a number from 0 to 60",
					"trig-validation-message": "Validating a number from 0 to 500",
					"eglu-validation-message": "Validating a number from 0 to 199",
					"calcLdl-validation-message": "Validating a number from 0 to 130",
					"tcHdl-validation-message": "Validating a number from 0 to 5 with optional decimal places",
					"ldlHdl-validation-message": "Validating a number from 0 to 3.5 with optional decimal places",
					"nonHdl-validation-message": "Validating a number from 0 to 130"
				},
				"binah": {
					"blood-pressure": "Blood pressure",
					"breating-rate": "Breathing Rate",
					"completed": "Completed",
					"face-not-detected": "Face Not Detected",
					"good-position": "Good Position",
					"head-tilted": "Head Tilted",
					"hearth-rate-variability": "HRV",
					"hearth-rate": "Heart rate",
					"session-state": "Session State",
					"stress-level-extreme": "Extreme",
					"stress-level-high": "High",
					"stress-level-low": "Low",
					"stress-level-mild": "Mild",
					"stress-level-normal": "Normal",
					"stress-level-unknown": "Unknown",
					"stress-level": "Stress",
					"too-far": "You Are Too Far",
					"uneven-lighting": "Uneven Lighting",
					"unsupported-orientation": "Unsupported orientation",
					"hold-tight": "Hold tight",
					"still-scanning": "We are still scanning your face."
				},
				"blood-pressure-check-form": {
					"auto-fill": "Auto Fill",
					"systolic": "Systolic Blood Pressure",
					"diastolic": "Diastolic Blood Pressure",
					"pulse": "Pulse Rate",
					"time": "Time",
					"date": "Date",
					"systolic-short": "SBP",
					"diastolic-short": "DIA",
					"pulse-short": "PUL",
					"systolic-validation-message": "Validating a number from 90 to 140",
					"diastolic-validation-message": "Validating a number from 60 to 90",
					"pulse-validation-message": "Validating a number from 60 to 100",
					"time-validation-message": "Validating the time format",
					"date-validation-message": "Validating the date format"
				},
				"covid-trinary": {
					"comment-title": "Comments?",
					"comment-warning": "Do not put any personal customer information here",
					"question": "What are the test-taker's interpretation of the test results?"
				},
				"diagnostic-summary": {
					diagnostic: "Observation",
					result: "Patient Reported",
					time: "Time"
				},
				"drug": {
					"interpretations": {
						positive: "Presumptive {{widgets.interpretations.positive}}",
						negative: "{{widgets.interpretations.negative}}",
						invalid: "{{widgets.interpretations.invalid}}"
					},
					"form": {
						positive: "{{widgets.interpretations.positive}}",
						negative: "{{widgets.interpretations.negative}}",
						invalid: "{{widgets.interpretations.invalid}}"
					},
					"form-new": {
						two_lines: "{{widgets.interpretations.two_lines}}",
						top_line: "{{widgets.interpretations.top_line}}",
						bottom_line: "{{widgets.interpretations.bottom_line}}",
						no_line: "{{widgets.interpretations.no_line}}"
					},
					"conditions": {
						amphetamine: "Amphetamine",
						cocaine: "Cocaine",
						methamphetamine: "Methamphetamine",
						methadone: "Methadone",
						opiates: "Opiates",
						oxycodone: "Oxycodone",
						phencyclidine: "Phencyclidine",
						barbiturates: "Barbiturates",
						benzodiazepines: "Benzodiazepines",
						thc: "THC",
						amp: "AMP",
						bar: "BAR",
						bzo: "BZO",
						coc: "COC",
						mtd: "MTD",
						met: "MET",
						opi: "OPI",
						oxy: "OXY",
						pcp: "PHE"
					}
				},
				"human-box-checker": {
					"activate-audio": "Activate Audio",
					"audio-off-text": "AUDIO IS OFF AND THE CUSTOMER CANNOT HEAR YOU!",
					"note-label": "NOTE: ",
					"option-failed": "Options failed to load. Please continue.",
					"say": "SAY: Welcome to eMed! Will you please hold your test box up to the camera so that I can see it?",
					"select-option":
						'Please select the option that best represents the photo on the left. If you\'re not sure, please click "activate audio" to speak with the customer.',
					"speak-to-customer-text": "Please speak to the customer to see which test they have.",
					"which-test": "Which test is this?"
				},
				"imaging": {
					"drivers-license-found": "Drivers License Found",
					"drivers-license-not-found": "Drivers License Not Found",
					"expired-test": "EXPIRED TEST",
					"not-expired-test": "NOT EXPIRED TEST"
				},
				"insurance-card-form": {
					"auto-fill": "Auto Fill",
					"child": "Child",
					"group-id-validation-message":
						"The group number needs to contain at least 3 characters and should be alphanumeric.",
					"group-id": "Group Number",
					"holder-profile-dob-message":
						"The policy holder date of birth must be a valid date, and the policy holder must be at least 18 years old.",
					"holder-profile-dob": "Policy Holder Date of Birth",
					"holder-relationship": "Relationship",
					"inactive": "Inactive",
					"member-id-validation-message":
						"The member ID needs to contain at least 3 characters and should be alphanumeric.",
					"member-id": "Member ID",
					"other": "Other",
					"payer-id-hint-message-prefix": "Hint: ",
					"payer-id-validation-message":
						"The insurance plan needs to contain 5 character string that may include numbers and letters.",
					"payer-id": "Payer ID",
					"payer-name-id-search-placeholder": "Search...",
					"payer-name-id-search": "Payer Name/ID Search",
					"payer-phone-validation-message": "The insurance company phone needs to be 10 digits.",
					"payer-phone": "Insurance Company Phone",
					"plan-type": "Insurance Type",
					"primary": "Primary",
					"secondary": "Secondary",
					"self": "Self",
					"spouse": "Spouse"
				},
				"observation-form": {
					"false-label": "False",
					"form-label": "",
					"not-readable": "Not Readable",
					"true-label": "True"
				},
				"option-selection-widget": {
					"form-label": "",
					"instructions": "",
					"loading": "Loading...",
					"unknown-selection": ""
				},
				"photo-viewer": {
					"retrieval-error": "There was an error attempting to retrieve the file"
				},
				"photo-viewer-best-photo": {
					"submit-button": "Submit Best Photo"
				},
				"proctor-temperature-scanner": {
					"loading": "Loading...",
					"not-readable": "Not Readable",
					"option-select": "Select...",
					"record-temperature-label": "Please record the temperature default",
					"waiting-for-temperature-scanner": "Select Temperature See Virtual Image"
				},
				"proctor-voucher-status": {
					"no-access-card": "No Access Card",
					"unable-to-scan": "Unable to Scan"
				},
				"treat-consent-widget": {
					"accepted-message": "the customer's data will be reviewed by a clinician",
					"no": "No",
					"not-accepted-message": "the customer's data will not be further reviewed",
					"submit-answer": "Submit Answer",
					"title": " ",
					"yes": "Yes"
				},
				"trinary-observation-form": {
					"covid-trinary": {
						"comment-title": "{{widgets.covid-trinary.comment-title}}",
						"comment-warning": "{{widgets.covid-trinary.comment-warning}}",
						"question": "{{widgets.covid-trinary.question}}"
					},
					"error-submit-results": "There was a problem submitting this result. Please try again.",
					"interpretations": {
						invalid: "{{widgets.interpretations.invalid}}",
						negative: "{{widgets.interpretations.negative}}",
						positive: "{{widgets.interpretations.positive}}",
						other: "{{widgets.interpretations.other"
					}
				},
				"trinary-results-form": {
					"agreement-label": "Do you agree with the test-taker's interpretation of these results?",
					"comments-label": "Comments?",
					"interpretations": {
						positive: "{{widgets.interpretations.positive}}",
						negative: "{{widgets.interpretations.negative}}",
						invalid: "{{widgets.interpretations.invalid}}",
						other: "{{widgets.interpretations.other"
					},
					"label": "What are the test-taker's interpretation of the test results?",
					"privacy-label": "Do not put any personal customer information here",
					"submit": "Submit Results"
				},
				"user-temperature-status": {
					"recorded-temperature-label": "Your temperature has been recorded as",
					"wait-to-record-label": "Please wait while we record your temperature"
				},
				"uti": {
					interpretations: {
						negative: "{{widgets.interpretations.negative}}",
						positive: "{{widgets.interpretations.positive}}",
						trace: "Trace"
					},
					conditions: {
						leukocytes: "LEUKOCYTE",
						nitrates: "NITRITE"
					},
					form: {
						"leukocytes": "{{widgets.uti.conditions.leukocytes}}",
						"nitrates": "{{widgets.uti.conditions.nitrates}}",
						"uti-title": "URINARY TRACT INFECTION TEST"
					}
				},
				"uti-results-form": {
					"bottom-row-instructions":
						"Look at the bottom pad of your test. Select the letter that best matches the color.",
					"top-row-instructions":
						"sssLook at the top pad of your test strip. Find the number that best matches the color on the test card and select that box above."
				},
				"vph": {
					"experiencing-symptoms": "Experiencing Symptoms",
					"form": {
						abnormal: "Abnormal (5.0 or greater)",
						normal: "Normal"
					},
					"interpretations": {
						abnormal: "5.0 (Abnormal)",
						normal: "4.5 (Normal)"
					},
					"no": "No",
					"ph-level": "pH Level",
					"yes": "Yes"
				},
				"device-selector": {
					name: "Device Selector"
				},
				"weight-capture": {
					"device": "I witnessed their weight on a scale",
					"imperial": "Stone",
					"kg-validation-message": "Please enter a positive number. Decimals are allowed.",
					"kg": "kg",
					"lbs-validation-message": "Please enter a value less than 14",
					"lbs": "lbs",
					"method-placeholder": "Choose method",
					"method-validation-message": "Please select a method",
					"method": "How was the patient's weight provided?",
					"metric": "Kilogram",
					"stone-validation-message": "Stone must be entered as a whole number",
					"stone": "stone",
					"verbal": "Customer verbally provided weight",
					"pounds": "Pounds"
				},
				"timer": {
					"restart-timer": "RESTART TIMER"
				},
				"address-form": {
					"fields": {
						"address1": "Address Line 1",
						"address2": "Address Line 2",
						"city": "City",
						"country": "Country",
						"postal-code": "Postal Code",
						"state": "State"
					},
					"placeholders": {
						"address1": "Address Line 1",
						"address2": "Address Line 2",
						"city": "City",
						"country": "Country",
						"postal-code": "Postal Code",
						"state": "Select state"
					},
					"errors": {
						"retrieval-error": "There was an error attempting to retrieve the address",
						"save-error": "There was an error attempting to save the address. Please try again.",
						"validation-error": "Please fill out all required fields",
						"field-required": "This field is required."
					},
					"success": "Address saved successfully!",
					"loading": "Loading address. Please wait...",
					"edit-hint": "Click to edit",
					"reload-hint": "Click to reload",
					"save": "Save",
					"saved": "Saved",
					"cancel": "Cancel"
				},
				"device-urn-selector": {
					"fields": {
						"device-urn": "Device URN",
						"no-device-urn-option": "URN not one of these"
					},
					"placeholders": {
						"device-urn": "Select device URN",
						"no-device-urn": "No device URN available",
						"please-wait": "Please wait..."
					},
					"errors": {
						"retrieval-error": "There was an error attempting to retrieve the available device URNs",
						"save-error": "There was an error attempting to save the device URN. Please try again."
					},
					"loading-edit": "Loading available device URNs. Please wait...",
					"loading-readonly": "Loading. Please wait...",
					"reload-hint": "Click to reload",
					"save": "Save",
					"saved": "Saved",
					"success": "Device URN saved successfully!",
					"saved-data": "All data is saved",
					"unsaved-data": "You have unsaved data"
				}
			},
			"login-error": {
				"title": "There was a problem logging you in.",
				"body": "Your link may have expired.",
				"title-embedmode": "Something went wrong.",
				"body-embedmode": "Please try again."
			}
		}
	},
	es: {
		translation: {
			"common": {
				start: "Empezar",
				confirmation: "¿Estás seguro de que quieres enviar?"
			},
			"scale-landing": {
				"weight-capture": "Vamos a capturar tu peso",
				"instruction": "Por favor, súbase a la báscula y apunte la cámara trasera para capturar la pantalla de peso.",
				"instruction-item-1": "Ropa ligera sin zapatos",
				"instruction-item-2": "Báscula en una superficie plana y estable"
			},
			"navigator": {
				"back-btn": "Retroceso",
				"submit-btn": "Entregar"
			},
			"agent-wait-time":
				"Pedimos disculpas por la espera. Nuestro equipo actualmente está experimentando una demanda mayor de lo habitual. Su tiempo de espera actual puede alcanzar hasta {{WAIT_TIME}} minutos. Si este momento no funciona para usted, puede volver a intentarlo más tarde para obtener un servicio potencialmente más rápido. Gracias por su paciencia. Estamos trabajando arduamente para ayudarlo lo más rápido posible.",
			"agent-wait-soon": "Estaremos contigo en breve.",
			"agent-long-wait":
				"Pedimos disculpas por la espera. Nuestro equipo actualmente está experimentando una demanda mayor de lo habitual. Su tiempo de espera actual es de más de 30 minutos. Si este momento no funciona para usted, puede volver a intentarlo más tarde para obtener un servicio potencialmente más rápido. Gracias por su paciencia. Estamos trabajando arduamente para ayudarlo lo más rápido posible.",
			"agent-wait-time-high-priority":
				"Estás en una cola de espera de alta prioridad; te conectaremos lo antes posible.",
			"all-set": "¡Estás listo!",
			"check-mic": "Revisemos tu micrófono",
			"checking": "Comprobación",
			"connect-agent": "Espere mientras lo conectamos con un Supervisor de Telesalud.",
			"connection-lost": "Se perdió la conexión",
			"continue": "Continuar",
			"could-not-hear": "Nosotros no pudimos escuchar nada.",
			"different-device": "Probemos con un dispositivo diferente.",
			"duplicate-sessions":
				"Tiene una sesión abierta en otra ventana. Cierre la otra ventana y actualice esta página para volver a intentarlo.",
			"failed": "Falla",
			"finish": "Terminar",
			"for-additional-help": "Haga clic aquí para obtener ayuda adicional",
			"hear-you": "¡Genial, te escuchamos fuerte y claro!",
			"how-about-now": "¿Qué tal ahora?",
			"have-questions-visit": "¿Tiene alguna pregunta? Visite el enlace",
			"listening-on": "Escuchando",
			"loading": "Cargando",
			"manual-settings": "Ajustes manuales",
			"need-permission": "Necesita permiso",
			"next": "Próxima",
			"no-access-card": "Sin Tarjeta de Acceso",
			"Note": "Nota",
			"not-detected": "NO DETECTADO",
			"playing_on": "Jugando en",
			"refresh-page-help": "Actualizar esta página puede ayudar a resolver el problema.",
			"save-settings":
				"Gracias por su paciencia, guardaremos su configuración para usarla en el futuro para que no tenga que volver a hacer esto.",
			"say-mic": "Intenta decir algo en tu micrófono.",
			"scanner-error": "No se pudo escanear",
			"scanning": "Exploración",
			"start-device-setup":
				"Haga clic en el botón de inicio para comenzar el proceso de configuración de su dispositivo.",
			"stop-sound": "Detener el sonido",
			"success": "Éxito",
			"test-sound": "Prueba de sonido",
			"thankyou-for-choosing": "Gracias por elegir eMed.",
			"thankyou-for-choosing-shemed": "Gracias por elegir SheMed.",
			"thankyou-for-choosing-hemed": "Gracias por elegir HeMed.",
			"to-reconnect": "para volver a conectarse",
			"to-refresh-page": "para actualizar la página",
			"try-again": "Intentar otra vez",
			"unable-to-scan": "Incapaz de Escanear",
			"click-here": "Haga clic aquí",
			"warnings": {
				"warning": "Advertencia",
				"reconnecting": "Reconectando...",
				"slow-internet": "Internet lento",
				"your-internet-connection-is-slow": "Su conexión-a-internet-es-lenta"
			},
			"av-errors": {
				"av-error-occurred": "Ocurrió un error de audio/video",
				"microphone":
					"No se puede acceder a su micrófono. Es posible que no se hayan concedido los permisos. Por favor refresque la página y conceda permisos.",
				"speaker":
					"No se puede enviar audio a sus altavoces. Es posible que no se hayan concedido los permisos. Por favor refresque la página y conceda permisos.",
				"camera":
					"No se puede acceder a su cámara. Es posible que no se hayan concedido los permisos. Por favor refresque la página y conceda permisos."
			},
			"readiness-checker": {
				"continue": "{{continue}}",
				"check-motion-and-orientation": "Movimiento y orientación",
				"check-motion-and-orientation-failed":
					"Compruebe que ha habilitado los permisos para el movimiento e inténtelo de nuevo.",
				"check-permissions": "Permisos de dispositivos",
				"check-permissions-failed":
					"Por favor, revise que haya concedido permisos para usar la cámara y el micrófono, y vuelva a intentar.",
				"audio-input-permission": "El micrófono requiere permiso del navegador",
				"camera": "Cámara",
				"check-device-ready": "Comprobemos su dispositivo",
				"check-device-ready-note":
					"Se conectará al procedimiento siguiente; si desea usar auriculares, conéctelos ahora",
				"click-here": "{{click-here}}",
				"confirm-continue":
					"Hay un problema con su altavoz. Si tiene dificultades de audio durante su sesión, su supervisor de telesalud puede comunicarse con usted mediante la ventana de chat.",
				"device-problem": "Hay un problema con su",
				"device-ready": "Su dispositivo está listo",
				"disclaimer":
					"*Para brindar la mejor experiencia de prueba, eMed accederá a su cámara y micrófono. Si prefiere no habilitarlas, aún puede usar el chat para comunicarse con el supervisor, pero algunas funciones serán limitadas.",
				"hear-sound": "¿Escuchas el sonido que estamos reproduciendo?",
				"microphone": "Micrófono",
				"microphone-permission": "Su navegador de Internet no tiene permiso para acceder a su micrófono.",
				"network": "Redes",
				"no": "No",
				"skip": "Saltar",
				"speaker": "Altavoz",
				"start": "Comienzo",
				"start-testing-button": "Let's start your testing",
				"start-the-test": "Empezar la prueba",
				"steps-failed": "Uno o más pasos han fallado.",
				"thanks-for-providing-information": "Comprobemos si su dispositivo está listo",
				"readiness-steps": {
					"step-1": "Permita a eMed el acceso a su cámara y micrófono* cuando se le solicite.",
					"step-2": "Comprobaremos su dispositivo para internet, cámara, micrófono y altavoz.",
					"step-3": "Conéctese a la guía del Supervisor para su sesión de prueba."
				},
				"to-try-again": "para volver a intentarlo.",
				"video-permission": "Su navegador de Internet no tiene permiso para acceder a su cámara.",
				"yes": "Sí",
				"device-check-failed": "Ha fallado la validación de uno o más dispositivos",
				"confirm-device-settings":
					"Por favor confirme en la configuración de su dispositivo que el uso de la cámara y micrófono están habilitados para su navegador.",
				"troubleshooting-guides-title":
					"Si está teniendo problemas ubicando esta caracterpistica en las configuraciones de su dispositivo, por favor refiera al siguiente material.",
				"using-mobile": "Si está usando un dispositivo móvil",
				"using-desktop-laptop": "Si está usando una computadora de escritorio o una laptop",
				"still-having-trouble_us":
					"¿Aún tiene problemas para conectarse? Contacte con el servicio al cliente de eMed <a class='has-text-link' href='https://support.emed.com/s/?language=en_US' target='_blank'><u>aquí</u></a>.",
				"still-having-trouble_uk":
					"¿Aún tiene problemas para conectarse? Contacte con el servicio al cliente de eMed <a class='has-text-link' href='https://emed.com/uk/contact' target='_blank'><u>aquí</u></a>.",
				"confirm-device-settings-shemed":
					"Por favor, confirme que la aplicación SheMed tiene permiso para usar la cámara y el micrófono de su dispositivo.",
				"device-check-failed-shemed": "Una o más verificaciones del dispositivo han fallado.",
				"try-again-shemed": "Inténtalo de nuevo",
				"confirm-device-settings-hemed":
					"Por favor, confirme que la aplicación HeMed tiene permiso para usar la cámara y el micrófono de su dispositivo.",
				"device-check-failed-hemed": "Una o más verificaciones del dispositivo han fallado.",
				"try-again-hemed": "Inténtalo de nuevo",
				"try-again": "Inténtalo de nuevo",
				"device-guides-shemed": {
					iphone: {
						"step-1": "Abra Configuración en su iPhone",
						"step-2": "Pulse Privacidad y Seguridad",
						"step-3": "Seleccione Cámara",
						"step-4": 'Ubique la aplicación SheMed y active el interruptor en la posición "encendido"',
						"step-5": "Regrese al menú de Privacidad y Seguridad y repita estos pasos para el Micrófono",
						"title": "Si utiliza un <b>iPhone (iOS)</b>:",
						"more-information":
							"Para obtener más información sobre cómo gestionar el acceso a la cámara y el micrófono en su iPhone, visite el soporte de Apple <a class='has-text-link' href='https://support.apple.com/en-gb/contact' target='_blank'><u>aquí</u></a>."
					},
					android: {
						"step-1": "Acceda a la configuración de su teléfono",
						"step-2": 'Seleccione "Aplicaciones" o "Apps"',
						"step-3": "Busque y toque la aplicación SheMed",
						"step-4": 'Toque "Permisos"',
						"step-5": 'Active las opciones de "Cámara" y "Micrófono" en "Permitir"',
						"title": "Si utiliza un <b>dispositivo Android</b>:",
						"more-information":
							"Para obtener más información sobre cómo gestionar el acceso a la cámara y el micrófono en su dispositivo Android, visite el soporte de Android <a class='has-text-link' href='https://support.google.com/android/?hl=en-GB' target='_blank'><u>aquí</u></a>."
					}
				},
				"device-guides-hemed": {
					iphone: {
						"step-1": "Abra Configuración en su iPhone",
						"step-2": "Pulse Privacidad y Seguridad",
						"step-3": "Seleccione Cámara",
						"step-4": 'Ubique la aplicación HeMed y active el interruptor en la posición "encendido"',
						"step-5": "Regrese al menú de Privacidad y Seguridad y repita estos pasos para el Micrófono",
						"title": "Si utiliza un <b>iPhone (iOS)</b>:",
						"more-information":
							"Para obtener más información sobre cómo gestionar el acceso a la cámara y el micrófono en su iPhone, visite el soporte de Apple <a class='has-text-link' href='https://support.apple.com/en-gb/contact' target='_blank'><u>aquí</u></a>."
					},
					android: {
						"step-1": "Acceda a la configuración de su teléfono",
						"step-2": 'Seleccione "Aplicaciones" o "Apps"',
						"step-3": "Busque y toque la aplicación HeMed",
						"step-4": 'Toque "Permisos"',
						"step-5": 'Active las opciones de "Cámara" y "Micrófono" en "Permitir"',
						"title": "Si utiliza un <b>dispositivo Android</b>:",
						"more-information":
							"Para obtener más información sobre cómo gestionar el acceso a la cámara y el micrófono en su dispositivo Android, visite el soporte de Android <a class='has-text-link' href='https://support.google.com/android/?hl=en-GB' target='_blank'><u>aquí</u></a>."
					}
				},
				"device-guides": {
					iphone: {
						"step-1": "Abra Configuración en su iPhone",
						"step-2": "Pulse Privacidad y Seguridad",
						"step-3": "Seleccione Cámara",
						"step-4": 'Ubique la aplicación eMed y active el interruptor en la posición "encendido"',
						"step-5": "Regrese al menú de Privacidad y Seguridad y repita estos pasos para el Micrófono",
						"title": "Si utiliza un <b>iPhone (iOS)</b>:",
						"more-information":
							"Para obtener más información sobre cómo gestionar el acceso a la cámara y el micrófono en su iPhone, visite el soporte de Apple <a class='has-text-link' href='https://support.apple.com/en-gb/contact' target='_blank'><u>aquí</u></a>."
					},
					android: {
						"step-1": "Acceda a la configuración de su teléfono",
						"step-2": 'Seleccione "Aplicaciones" o "Apps"',
						"step-3": "Busque y toque la aplicación eMed",
						"step-4": 'Toque "Permisos"',
						"step-5": 'Active las opciones de "Cámara" y "Micrófono" en "Permitir"',
						"title": "Si utiliza un <b>dispositivo Android</b>:",
						"more-information":
							"Para obtener más información sobre cómo gestionar el acceso a la cámara y el micrófono en su dispositivo Android, visite el soporte de Android <a class='has-text-link' href='https://support.google.com/android/?hl=en-GB' target='_blank'><u>aquí</u></a>."
					},
					mac: {
						"step-1": "Abra Preferencias del Sistema",
						"step-2": "Seleccione Seguridad y Privacidad",
						"step-3": "Haga clic en la pestaña Privacidad",
						"step-4": "Seleccione Cámara",
						"step-5": 'Ubique la aplicación eMed y active el interruptor en la posición "encendido"',
						"title": "Si utiliza un <b>Mac</b>:",
						"more-information":
							"Para obtener más información sobre cómo gestionar el acceso a la cámara y el micrófono en su Mac, visite el soporte de Apple <a class='has-text-link' href='https://support.apple.com/en-gb/contact' target='_blank'><u>aquí</u></a>."
					},
					windows: {
						"step-1": 'Vaya a "Inicio > Configuración > Privacidad"',
						"step-2": 'Elija "Cámara" o "Micrófono" según el permiso que desee otorgar',
						"step-3": 'Seleccione "Cámara" o "Micrófono" en el lado izquierdo',
						"step-4":
							'Asegúrate de que el interruptor junto a "Permitir que las aplicaciones accedan a tu cámara/micrófono" esté activado',
						"title": "Si utiliza un <b>Windows</b>:",
						"more-information":
							"ara obtener más información sobre cómo administrar el acceso a la cámara y al micrófono en su PC con Windows, visite el soporte de Microsoft <a class='has-text-link' href='https://support.microsoft.com/en-us' target='_blank' ><u>aquí</u></a>."
					}
				},
				"proceed-anyway-shemed":
					"Si los permisos están habilitados y aún ve esta pantalla, aún puede conectarse con un supervisor haciendo clic a continuación.",
				"proceed-anyway-cta-shemed": "Continuar de todos modos",
				"still-having-trouble-shemed":
					"¿Aún tiene problemas para conectarse? Contacte con el servicio al cliente de SheMed <a class='has-text-link' href='https://support.shemed.co.uk/s/' target='_blank'><u>aquí</u></a>.",
				"proceed-anyway-hemed":
					"Si los permisos están habilitados y aún ve esta pantalla, aún puede conectarse con un supervisor haciendo clic a continuación.",
				"proceed-anyway-cta-hemed": "Continuar de todos modos",
				"still-having-trouble-hemed":
					"¿Aún tiene problemas para conectarse? Contacte con el servicio al cliente de HeMed <a class='has-text-link' href='https://support.hemed.com/s/' target='_blank'><u>aquí</u></a>.",
				"proceed-anyway":
					"Si los permisos están habilitados y todavía ve esta pantalla, aún puede conectarse con un supervisor haciendo clic a continuación.",
				"proceed-anyway-cta": "Continuar de todos modos"
			},
			"widgets": {
				"continue": "{{continue}}",
				"incomplete-warning": "Complete el formulario y vuelva a intentarlo.",
				"interpretations": {
					invalid: "Inválido",
					negative: "Negativo",
					other: "Otro",
					positive: "Positivo",
					two_lines: "Dos Líneas",
					top_line: "Línea Superior",
					bottom_line: "Línea Inferior",
					no_line: "Sin Línea"
				},
				"loading-failure": "No se puede recuperar el resultado",
				"loading-result": "Recuperando resultado",
				"no-photo-title": "NO SE ENCONTRO NINGUNA FOTO",
				"refresh-image": "ACTUALIZAR IMAGEN",
				"save-failed": "No se pudieron guardar los resultados. Inténtalo de nuevo",
				"select": "Seleccione",
				"submit": "Enviar",
				"camera-widget": {
					"button-capture-photo": "capturar foto",
					"capture-error": "Hubo un problema al capturar su imagen. Por favor, actualice y pruebe de nuevo.",
					"confirm-photo": "Se ve bien",
					"instruction-message": "Coloque su termómetro sobre un fondo negro y tome una foto clara:",
					"reject-photo": "volver a tomar",
					"save-error": "Hubo un problema al guardar el resultado. Inténtalo de nuevo.",
					"verify-image-message": "Si la foto es clara y legible, haga clic en 'Se ve bien' para continuar:",
					"take-a-photo": "Utilizará la cámara de su dispositivo para tomar una foto de su prueba.",
					"clear-photo-question": "¿Están todos los artículos visibles y claros?",
					"source-error":
						"No pudimos acceder al flujo de video; por favor verifica los permisos de la cámara, el uso de otras aplicaciones y tu conexión a internet.",
					"successful-upload": "Carga exitosa",
					"processing": "Procesando",
					"cancel": "Cancelar",
					"button-instructions": "TÓMATE UNA FOTO",
					"native-capture-heading": "¡Capturemos su resultados!",
					"native-capture-instruction":
						"Cuando esté listo para tomar la foto, por favor haga clic abajo y la cámara se abrirá para tomar la foto."
				},
				"covid-trinary": {
					"comment-title": "¿Comentarios?",
					"comment-warning": "No ponga ninguna información personal del cliente aquí",
					"question":
						"¿Cuál es la interpretación de los resultados de la prueba por parte de la persona que rinde el examen?"
				},
				"diagnostic-summary": {
					diagnostic: "Observación",
					result: "Paciente Informado",
					time: "Tiempo"
				},
				"drug": {
					interpretations: {
						invalid: "{{widgets.interpretations.invalid}}",
						negative: "{{widgets.interpretations.negative}}",
						positive: "Presunto {{widgets.interpretations.positive}}"
					},
					form: {
						invalid: "{{widgets.interpretations.invalid}}",
						negative: "{{widgets.interpretations.negative}}",
						positive: "{{widgets.interpretations.positive}}"
					},
					conditions: {
						amphetamine: "Anfetamina",
						cocaine: "Cocaína",
						methamphetamine: "Metanfetamina",
						methadone: "Metadona",
						opiates: "Opiáceos",
						oxycodone: "Oxicodona",
						phencyclidine: "Fenciclidina",
						thc: "THC"
					}
				},
				"human-box-checker": {
					"audio-off-text": "¡EL AUDIO ESTA APAGADO Y EL CLIENTE NO PUEDE ESCUCHARLO!",
					"activate-audio": "Activar el audio.",
					"note-label": "NOTA: ",
					"option-failed": "Las opciones no se pudieron cargar. Por favor continúa.",
					"say": "DECIR: ¡Bienvenido a eMed! ¿Podría acercar su caja de pruebas a la cámara para que pueda verla?",
					"select-option":
						'Por favor, seleccione la opción que mejor represente la foto de la izquierda. Si no está seguro, haga clic en "activar el audio" habla con el cliente.',
					"speak-to-customer-text": "Por favor, hable con el cliente para ver qué prueba tiene.",
					"which-test": "¿Qué prueba es esta?"
				},
				"imaging": {
					"drivers-license-found": "Licencia de conducir encontrada",
					"drivers-license-not-found": "Licencia de conducir no encontrada",
					"expired-test": "PRUEBA VENCIDA",
					"not-expired-test": "PRUEBA NO CADUCADO"
				},
				"insurance-card-form": {
					"auto-fill": "Relleno automático",
					"child": "Niño",
					"group-id-validation-message": "El número de grupo debe contener al menos 3 caracteres y ser alfanumérico.",
					"group-id": "Número de grupo",
					"holder-profile-dob-message":
						"La fecha de nacimiento del titular de la póliza debe ser una fecha válida, y el titular de la póliza debe tener al menos 18 años.",
					"holder-profile-dob": "Fecha de nacimiento del asegurado",
					"holder-relationship": "Relación",
					"inactive": "Inactivo",
					"member-id-validation-message": "El ID de afiliado debe contener al menos 3 caracteres y ser alfanumérico.",
					"member-id": "ID de miembro",
					"other": "Otros",
					"payer-id-hint-message-prefix": "Pista: ",
					"payer-id-validation-message":
						"El plan de seguro debe contener una cadena de 5 caracteres que puede incluir números y letras.",
					"payer-id": "Plan de seguro",
					"payer-name-id-search-placeholder": "Buscar en...",
					"payer-name-id-search": "Búsqueda de nombre/ID de pagador",
					"payer-phone-validation-message": "El teléfono de la compañía de seguros debe tener 10 dígitos.",
					"payer-phone": "Teléfono de la compañía de seguros",
					"plan-type": "Tipo de seguro",
					"primary": "Principal",
					"secondary": "Secundaria",
					"self": "Auto",
					"spouse": "Cónyuge"
				},
				"option-selection-widget": {
					"instructions": "Seleccione de la lista a continuación...",
					"loading": "Cargando...",
					"unknown-selection": "No tengo síntomas"
				},
				"observation-form": {
					"false-label": "Falso",
					"form-label": "",
					"not-readable": "No se puede leer",
					"true-label": "Verdadero"
				},
				"photo-viewer": {
					"retrieval-error": "Hubo un error al intentar recuperar el archivo."
				},
				"photo-viewer-best-photo": {
					"submit-button": "Presentar la mejor foto"
				},
				"proctor-temperature-scanner": {
					"loading": "Cargando...",
					"not-readable": "No se puede leer",
					"option-select": "Seleccione...",
					"record-temperature-label": "Por favor registre la temperatura",
					"waiting-for-temperature-scanner": "Por favor registre la temperatura"
				},
				"proctor-voucher-status": {
					"no-access-card": "Sin Tarjeta de Acceso",
					"unable-to-scan": "Incapaz de Escanear"
				},
				"treat-consent-widget": {
					"accepted-message": "los datos del cliente serán revisados ​​por un médico",
					"no": "No",
					"not-accepted-message": "los datos del cliente no se revisarán más",
					"submit-answer": "Enviar respuesta",
					"title": " ",
					"yes": "Sí"
				},
				"trinary-observation-form": {
					"covid-trinary": {
						"comment-title": "{{widgets.covid-trinary.comment-title}}",
						"comment-warning": "{{widgets.covid-trinary.comment-warning}}",
						"question": "{{widgets.covid-trinary.question}}"
					},
					"error-submit-results": "Ocurrió un error al enviar el resultado. Por favor, intente de nuevo.",
					"interpretations": {
						invalid: "{{widgets.interpretations.invalid}}",
						negative: "{{widgets.interpretations.negative}}",
						other: "{{widgets.interpretations.other",
						positive: "{{widgets.interpretations.positive}}"
					}
				},
				"trinary-results-form": {
					"agreement-label": "¿Está de acuerdo con la interpretación de estos resultados por parte del cliente?",
					"interpretations": {
						positive: "{{widgets.interpretations.positive}}",
						negative: "{{widgets.interpretations.negative}}",
						invalid: "{{widgets.interpretations.invalid}}",
						other: "{{widgets.interpretations.other"
					},
					"label": "¿Cuál es la interpretación de los resultados de la prueba por parte del cliente?",
					"privacy-label": "No ponga ninguna información personal del cliente aquí",
					"submit": "Enviar Resultados"
				},
				"user-temperature-status": {
					"recorded-temperature-label": "Tu temperatura ha sido registrada como",
					"wait-to-record-label": "Por favor registre la temperatura"
				},
				"uti": {
					interpretations: {
						negative: "{{widgets.interpretations.negative}}",
						positive: "{{widgets.interpretations.positive}}",
						trace: "Rastro"
					},
					conditions: {
						leukocytes: "LEUCOCITOS",
						nitrates: "NITRITOS"
					},
					form: {
						"leukocytes": "{{widgets.uti.conditions.leukocytes}}",
						"nitrates": "{{widgets.uti.conditions.nitrates}}",
						"uti-title": "PRUEBA DE INFECCIÓN DEL TRACTO URINARIO"
					}
				},
				"uti-results-form": {
					"bottom-row-instructions":
						"Mire la almohadilla inferior de su prueba. Seleccione la letra que mejor combine con el color.",
					"top-row-instructions":
						"Mire la almohadilla superior de su tira reactiva. Encuentre el número que mejor coincida con el color en la tarjeta de prueba y seleccione la casilla de arriba."
				},
				"vph": {
					"experiencing-symptoms": "Experimentar síntomas",
					"form": {
						abnormal: "Anormal (5.0 o superior)",
						normal: "Normal"
					},
					"interpretations": {
						abnormal: "5.0 (Anormal)",
						normal: "4.5 (Normal)"
					},
					"no": "No",
					"ph-level": "Nivel de pH",
					"yes": "Si"
				},
				"weight-capture": {
					"device": "Fui testigo de su peso en una balanza",
					"imperial": "Imperial",
					"kg-validation-message": "Por favor, introduzca un número positivo. Se permiten decimales.",
					"kg": "kg",
					"lbs-validation-message": "Por favor, introduzca un valor menor a 14",
					"lbs": "libras",
					"method-placeholder": "Elegir método",
					"method-validation-message": "Seleccione un método",
					"method": "Método de observación",
					"metric": "Métrico",
					"stone-validation-message": "La piedra debe ser ingresada como un número entero",
					"stone": "piedra",
					"verbal": "El cliente proporcionó verbalmente el peso",
					"pounds": "libras"
				},
				"timer": {
					"restart-timer": "REINICIAR TEMPORIZADOR"
				},
				"address-form": {
					"fields": {
						"address1": "Línea de Dirección 1",
						"address2": "Línea de Dirección 2",
						"city": "Ciudad",
						"country": "País",
						"postal-code": "Código Postal",
						"state": "Estado"
					},
					"placeholders": {
						"address1": "Línea de Dirección 1",
						"address2": "Línea de Dirección 2",
						"city": "Ciudad",
						"country": "País",
						"postal-code": "Código Postal",
						"state": "Seleccione estado"
					},
					"errors": {
						"retrieval-error": "Hubo un error al intentar recuperar la dirección",
						"save-error": "Hubo un error al intentar guardar la dirección. Por favor, inténtelo de nuevo.",
						"validation-error": "Por favor, complete todos los campos requeridos",
						"field-required": "Este campo es obligatorio."
					},
					"success": "¡Dirección guardada con éxito!",
					"loading": "Cargando dirección. Por favor, espere...",
					"edit-hint": "Haga clic para editar",
					"reload-hint": "Haga clic para recargar",
					"save": "Guardar",
					"saved": "Guardado",
					"cancel": "Cancelar"
				},
				"device-urn-selector": {
					"fields": {
						"device-urn": "URN del dispositivo",
						"no-device-urn-option": "El URN no es uno de estos"
					},
					"placeholders": {
						"device-urn": "Seleccione el URN del dispositivo",
						"no-device-urn": "No hay URN de dispositivo disponible",
						"please-wait": "Por favor, espere..."
					},
					"errors": {
						"retrieval-error": "Hubo un error al intentar recuperar los URN de dispositivos disponibles",
						"save-error": "Hubo un error al intentar guardar el URN del dispositivo. Por favor, inténtelo de nuevo."
					},
					"loading-edit": "Cargando URN de dispositivos disponibles. Por favor, espere...",
					"loading-readonly": "Cargando. Por favor, espere...",
					"reload-hint": "Haga clic para recargar",
					"save": "Guardar",
					"saved": "Guardado",
					"success": "¡URN del dispositivo guardado con éxito!",
					"saved-data": "Todos los datos han sido guardados",
					"unsaved-data": "Tiene datos sin guardar"
				}
			},
			"login-error": {
				"title": "Hubo un problema al iniciar sesión.",
				"body": "Es posible que su enlace haya expirado.",
				"title-embedmode": "Algo salió mal.",
				"body-embedmode": "Por favor, intente nuevamente."
			}
		}
	}
};
export const translations = [vlabtranslations, uilibtranslations];
export default translations;
